module.exports = __webpack_public_path__ + "static/img/Yves-du-Manoir-Stadium.0be7e43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Yves-du-Manoir-Stadium.jpg
// module id = Xef/
// module chunks = 0